import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IUserNotificationSettings } from "./routeType";

const { key, getPath } = getApi("users.notification.get");

type IExtractedRouteType =
  IUserNotificationSettings["usersNotificationsSettingsRetrieve"];

export type IGetUsersNotificationSettings =
  IPickSingleQuery<IExtractedRouteType>;

const getUserNotificationSetting: Fetcher<
  IGetUsersNotificationSettings["response"],
  IGetUsersNotificationSettings["variables"]
> = ({ userId, ...params }) => {
  return axiosClient.get(getPath({ userId }), { params });
};

export const useGetUserNotificationSetting = createQuery({
  queryKey: [key],
  fetcher: getUserNotificationSetting,
});
